import { z } from 'zod';
import { ReferralDashboard } from './referral-reports';

export const Breakdown = z.array(z.object({ key: z.string(), label: z.string(), count: z.number().int() }));
export type Breakdown = z.infer<typeof Breakdown>;

export const DashboardDto = z.object({
  cycleId: z.string().uuid(),
  totals: z.object({
    total: z.number().int(),
    highVisibility: z.number().int(),
    majorPlusCapacity: z.number().int(),
    followUpsDueSoon: z.number().int(),
    overdueFollowUps: z.number().int(),
    pendingScoring: z.number().int(),
  }),
  decision: Breakdown,
  hvDistribution: Breakdown,
  recommendationSource: Breakdown,
  capacity: Breakdown,
  referrals: ReferralDashboard.optional(),
});
export type DashboardDto = z.infer<typeof DashboardDto>;
